// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_3tyZVrFDUd3OacmKLuIEhJ","checkboxLabel":"qGh2BW0TMIstSadd0Q_NR","button":"zhIXnDZjQVjFv9AX8dMx7","error":"_2EgTTA3s7XPFG0sJU181IF"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscriptionSubscribe.scss
// module id = 2629
// module chunks = 0